"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Lists filtering methods: how value should be filtered.
 */
var FilterType;
(function (FilterType) {
    FilterType[FilterType["AMONG"] = 1] = "AMONG";
    FilterType[FilterType["NOT_AMONG"] = 2] = "NOT_AMONG";
    FilterType[FilterType["SPECIFIED"] = 3] = "SPECIFIED";
    FilterType[FilterType["UNSPECIFIED"] = 4] = "UNSPECIFIED";
    FilterType[FilterType["CONTAINS"] = 5] = "CONTAINS";
    FilterType[FilterType["NOT_CONTAINS"] = 6] = "NOT_CONTAINS";
    FilterType[FilterType["BEGINS_WITH"] = 7] = "BEGINS_WITH";
    FilterType[FilterType["TOP"] = 8] = "TOP";
    FilterType[FilterType["EQUALS"] = 9] = "EQUALS";
    FilterType[FilterType["NOT_EQUALS"] = 10] = "NOT_EQUALS";
    FilterType[FilterType["BETWEEN"] = 11] = "BETWEEN";
    FilterType[FilterType["NOT_BETWEEN"] = 12] = "NOT_BETWEEN";
    FilterType[FilterType["LESS_THAN"] = 13] = "LESS_THAN";
    FilterType[FilterType["LESS_THAN_OR_EQUALS"] = 14] = "LESS_THAN_OR_EQUALS";
    FilterType[FilterType["GREATER_THAN"] = 15] = "GREATER_THAN";
    FilterType[FilterType["GREATER_THAN_OR_EQUALS"] = 16] = "GREATER_THAN_OR_EQUALS";
    FilterType[FilterType["ON_OR_BEFORE"] = 17] = "ON_OR_BEFORE";
    FilterType[FilterType["ON_OR_AFTER"] = 18] = "ON_OR_AFTER";
    FilterType[FilterType["CURRENT"] = 19] = "CURRENT";
    FilterType[FilterType["NOT_CURRENT"] = 20] = "NOT_CURRENT";
    FilterType[FilterType["PREVIOUS"] = 21] = "PREVIOUS";
    FilterType[FilterType["NEXT"] = 22] = "NEXT";
    FilterType[FilterType["IS"] = 23] = "IS";
    FilterType[FilterType["IS_NOT"] = 24] = "IS_NOT";
    FilterType[FilterType["EMPTY"] = 25] = "EMPTY";
    FilterType[FilterType["TODAY"] = 26] = "TODAY";
    FilterType[FilterType["CURRENT_USER"] = 27] = "CURRENT_USER";
})(FilterType = exports.FilterType || (exports.FilterType = {}));
//# sourceMappingURL=filter-type.js.map